<template>
  <v-btn class="btn-cancel" @click="evOnClick"> CANCELAR </v-btn>
</template>

<script>
export default {
  name: "VBtnCancel",

  props: {
    loading: { type: Boolean, default: false },
  },

  methods: {
    async evOnClick(event) {
      this.$emit("click", event);
    },
  },
};
</script>

<style>
</style>